










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class WillUnsubscribe extends Vue {
  @Prop({ default: 'div' })
  readonly tag: string
}
